export const init = () => {
  const container = document.querySelector('.js-custom-gpt-container');
  const avatar = container?.querySelector('.js-custom-gpt-avatar');
  const chat = container?.querySelector('iframe');
  const pageActions = document.querySelectorAll('.js-page-actions-container .js-page-actions-action');

  if (!container || !avatar || !chat || !pageActions.length) return;
  const closeAllPopups = () => {
    pageActions.forEach((action) => {
      const podcastButton = action.querySelector('.js-page-actions-podcast');
      const popup = action.querySelector('.js-page-actions-window');
      podcastButton?.classList.remove('active');
      popup?.classList.remove('active');
    });
  };

  pageActions.forEach((action) => {
    const podcastButton = action.querySelector('.js-page-actions-podcast');
    const popup = action.querySelector('.js-page-actions-window');
    const createOverviewButton = action.querySelector('.js-page-actions-create-overview');
    const btn = action.querySelector('button');
    if (btn) {
      btn.addEventListener('mouseenter', () => {
        btn.classList.add('hovering');
      });

      btn.addEventListener('mouseleave', () => {
        btn.style.transitionDuration = '500ms';
        btn.classList.remove('hovering');
        setTimeout(() => {
          btn.style.transitionDuration = '';
        }, 500);
      });
    } 

    if (createOverviewButton) {
      createOverviewButton.addEventListener('click', (e) => {
        e.preventDefault();
        const prompt = createOverviewButton.dataset.prompt;
        if (!prompt || !chat?.src) return;

        closeAllPopups();

        const url = new URL(chat.src);
        url.searchParams.set('prompt', prompt);
        chat.src = url.toString();

        if (!chat.classList.contains('active')) {
        chat.classList.add('active');
        }

        if (!avatar.classList.contains('active')) {
          avatar.classList.add('active');
        }
      });
    }

    if (podcastButton && popup) {
      podcastButton.addEventListener('click', (e) => {
        e.preventDefault();

        const isActive = podcastButton.classList.contains('active');

        closeAllPopups();
        avatar.classList.remove('active');
        chat.classList.remove('active');

        if (!isActive) {
          podcastButton.classList.add('active');
          popup.classList.add('active');
        }
      });
    }
  });

  avatar.addEventListener('click', (e) => {
    e.preventDefault();
    const isActive = avatar.classList.contains('active');
    closeAllPopups();
    avatar.classList.toggle('active', !isActive);
    chat.classList.toggle('active', !isActive);
  });
};